import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/pt';
export const locale = {
  lang: 'pt',
  data: {
    data: {
      'GENERICSURVEY': {
        'CATALOGOS': {
          'broker': catalogos.institutos,
        },
        'TITULO': 'Relatório do estudo genérico',
        'SUBTITULO': 'Consulte o relatório genérico do inquérito, entrando',
        'CAMPOS': {
          'Token': 'Token:',
        },
        'RESULTADOS': {
          'CARGANDO': 'Carregamento dos resultados da pesquisa',
          'TITULO': 'Resultados',
          'ENCONTRADAS': 'Total de utilizadores encontrados',
          'DESCARGAR': 'Descarregar informação em formato Excel',
          'SINRESULTADOS': 'Não foram encontrados utilizadores para a ficha especificada'
        }
      }
    }
  }
};
